// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HighlightOutlinedSvg from "@ant-design/icons-svg/es/asn/HighlightOutlined";
import AntdIcon from '../components/AntdIcon';

var HighlightOutlined = function HighlightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HighlightOutlinedSvg
  }));
};

HighlightOutlined.displayName = 'HighlightOutlined';
export default React.forwardRef(HighlightOutlined);